import { Stack, Typography } from '@mui/material';
import FuelGun from 'app/icons/FuelGun';
import React from 'react';
import { paperProgressFuelTunkStyle } from '../TabPanelConditionStyle';
export const FuelTankIndicator = ({ in5Value, galileoskyDevice, conditionItem }) => {
    const displayValue = galileoskyDevice && in5Value ? Math.round(in5Value) : '-';
    return (React.createElement(Stack, { className: 'MuiPaperProgress-root', sx: (theme) => paperProgressFuelTunkStyle(theme, conditionItem) },
        React.createElement("div", { className: 'MuiPaperProgress-cover' },
            React.createElement(Typography, { className: 'MuiPaperProgress-degrees', variant: 'caption' }, displayValue)),
        React.createElement("div", { style: { height: '9px', marginTop: '4px' } },
            React.createElement(FuelGun, { fontSize: '29px' }))));
};
